import { render, staticRenderFns } from "./App.vue?vue&type=template&id=99f40574&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=99f40574&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f40574",
  null
  
)

export default component.exports